import './utilities/wdyr.ts';
import './polyfills/polyfills.ts';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import { REACT_APP_MOUNT } from 'tidee-life-config';
import env from './utilities/env.ts';

import { renderRoutes } from './routes/routes.tsx';
import 'react-tooltip/dist/react-tooltip.css';
import 'tidee-life-ui/src/styles/index.css';

if (env.MODE === 'production') {
    Sentry.init({
        dsn: 'https://b0c5a4c78b3c4547aed3c231467417e5@o74928.ingest.us.sentry.io/1363355',
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.browserProfilingIntegration(),
        ],
        release: '1.0.0',
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [/^https:\/\/app\.tidee\.com\/api/],
        // Set profilesSampleRate to 1.0 to profile every transaction.
        // Since profilesSampleRate is relative to tracesSampleRate,
        // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
        // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
        // results in 25% of transactions being profiled (0.5*0.5=0.25)
        profilesSampleRate: 1.0,
        environment: 'production',
        debug: false,
    });
} else if (env.MODE === 'gitlab') {
    Sentry.init({
        dsn: 'https://b0c5a4c78b3c4547aed3c231467417e5@o74928.ingest.us.sentry.io/1363355',
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.browserProfilingIntegration(),
        ],
        release: '1.0.0',
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [/^https:\/\/app\.tidee\.com\/api/],
        // Set profilesSampleRate to 1.0 to profile every transaction.
        // Since profilesSampleRate is relative to tracesSampleRate,
        // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
        // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
        // results in 25% of transactions being profiled (0.5*0.5=0.25)
        profilesSampleRate: 1.0,
        environment: 'gitlab',
        debug: true,
    });
}

const mountElement = document.getElementById(REACT_APP_MOUNT);
console.log(
    '[App] Mounting to:',
    REACT_APP_MOUNT,
    'Element found:',
    !!mountElement
);
if (mountElement) {
    const root = createRoot(mountElement);
    root.render(renderRoutes());
    console.log('[App] React app rendered');
} else {
    console.error('[App] Mount element not found:', REACT_APP_MOUNT);
}
